import * as yup from "yup";

export const creditNotesSchema = yup.object().shape({
  company_id: yup.number().min(0).label("Company"),
  reseller_id: yup.number().min(0).label("Reseller"),
  amount: yup.number().min(0).default(0).label("Amount"),
  order_id: yup.number().label("Order"),
});
